import { Injectable } from '@angular/core';

/** Platform-specific: register via provideSunCenterPrinting() (browser) or provideSunCenterPrintingServer() (SSR). */
@Injectable({
    providedIn: 'root',
    useFactory: (): never => {
        throw new Error(
            'No implementation for SunCenterPrintingService. Add provideSunCenterPrinting() or provideSunCenterPrintingServer() to your app config.',
        );
    },
})
export abstract class SunCenterPrintingService {
    public abstract print(blob: Blob): Promise<void>;
}
